// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "resources_js_empty-solana_js") return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return "" + chunkId + ".js";
};